<template>
  <div
    class='whatsapp-connect-container'
    :class="{ 'bg-custom': !mobile }"
  >
    <div class='qr-code-popup position-absolute' v-if='qrCodeVisible'>
      <div class='modal-header'>
        <h5 class='modal-title'>Scan to connect</h5>
        <button type='button' class='close' @click='hideQurCode'>
          <span aria-hidden='true'>&times;</span>
        </button>
      </div>
      <div class='modal-body'>
        <img
          class='qr-image'
          :src="require('../assets/images/whatsap-qr-code.svg')"
        />
      </div>
    </div>
    <a
      class='whatsapp-logo'
      :href='mobileRedirectLink'
      @click='toggleQrCodeVisiblity'
    >
      <img :src='require(`../assets/images/whatsapp-logo.svg`)' alt='' />
      <p v-if='!mobile'>Talk to an expert!</p>
    </a>
  </div>
</template>

<script>
export default {
  data () {
    return {
      qrCodeVisible: false,
      mobileRedirectLink: 'https://wa.me/message/NGGNUTJ5LLE2E1',
      mobile: false
    }
  },
  methods: {
    toggleQrCodeVisiblity (event) {
      if (!this.mobile) {
        event.preventDefault()
        this.qrCodeVisible = !this.qrCodeVisible
      }
    },
    hideQurCode () {
      this.qrCodeVisible = false
    },
    isMobile () {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true
      }
      return false
    }
  },
  mounted () {
    this.mobile = this.isMobile()
  }
}
</script>

<style lang='scss' scoped>
.whatsapp-connect-container {
  position: fixed;
  left: auto;
  top: auto;
  right: 1%;
  bottom: 1%;
  z-index: 100;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  cursor: pointer;
  .whatsapp-logo {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex-wrap: wrap;
    max-width: 6rem;
    text-decoration: none;
    img {
      width: 4rem;
    }
    p {
      text-align: center;
      margin: 0;
      color: $secondary;
      font-size: 0.8rem;
      font-weight: bold;
      margin-top: 0.25rem;
    }
  }
  .qr-code-popup {
    bottom: 8rem;
    right: 0;
    border-radius: 5px;
    background-color: rgba(255, 255, 255, 0.5);
    .modal-header {
      padding: 0.5rem;
      border: none;
      align-items: center;
      .modal-title {
        font-size: 0.9rem;
      }
      .close {
        padding: 0;
        margin: 0;
      }
    }
    .modal-body {
      padding: 0.5rem;
      padding-top: 0;
      .qr-image {
        width: 10rem;
      }
    }
  }
}
.bg-custom {
  background-color: rgba(255, 255, 255, 0.5);
  padding: 0.5rem 0;
  border-radius: 5px;
  bottom: 3%;
}
</style>
